import { render, staticRenderFns } from "./InstanceSubinstanceIndicator.vue?vue&type=template&id=6d00e851&scoped=true"
import script from "./InstanceSubinstanceIndicator.vue?vue&type=script&lang=js"
export * from "./InstanceSubinstanceIndicator.vue?vue&type=script&lang=js"
import style0 from "./InstanceSubinstanceIndicator.vue?vue&type=style&index=0&id=6d00e851&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d00e851",
  null
  
)

export default component.exports